/**
 * Endpoint to get web feature control settings.
 * @returns {string} The URL for getting web feature control settings.
 */
export const webFeatureControl = () => {
  return "/chocolate/v1/global/static/web/web_feature_control";
};
